import NewMessage from '@src/main/modules/messages/ui/mailbox/views/new-message/NewMessage';

const NewMessagePage = () => <NewMessage />;

export default NewMessagePage;
